<template>
  <el-dialog :visible.sync="visiable" width="480px" :show-close="false">
    <div class="ukey_dialog_banner">
      <el-icon class="el-icon-error ukey_dialog_banner_icon"></el-icon>
      <p class="ukey_dialog_banner_title">添加授权失败，请重新添加</p>
      <p class="ukey_dialog_banner_text">
        被授权人
        <span style="color: #3340ca">
          {{ personString }}
        </span>
        添加失败，请修改后重新提交
      </p>
    </div>
    <template slot="footer">
      <div class="ukey_dialog_button" @click="goSuccessUrl">完成授权</div>
      <div class="ukey_dialog_button submit" @click="visiable = false">
        继续添加
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visiable: false,
      personString: "",
      errorGrant: [],
    };
  },
  watch: {
    errorGrant: {
      handler() {
        let string = "";
        this.errorGrant.forEach((item, index) => {
          string = string + item.userName;
          if (index != this.errorGrant.length - 1) {
            string = string + "、";
          }
        });
        this.personString = string;
      },
    },
    deep: true,
  },
  methods: {
    show(list) {
      this.visiable = true;
      this.errorGrant = list;
    },
    goSuccessUrl() {
      this.$router.push("/auth-success");
    },
  },
};
</script>

<style lang="scss" scoped>
.ukey {
  &_dialog_banner {
    width: 352px;
    margin: 0 auto;
    position: relative;
    &_icon {
      position: absolute;
      top: 0;
      left: -40px;
      color: #ea4837;
      font-size: 24px;
    }
    &_title {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 24px;
      margin-bottom: 16px;
    }
    &_text {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #6a6c7d;
      line-height: 22px;
    }
    &_link {
      color: #3340ca;
      text-decoration: none;
      cursor: pointer;
    }
  }
  &_dialog_button {
    display: inline-block;
    width: 90px;
    height: 32px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 32px;
    cursor: pointer;
  }
}
.submit {
  background: #ca3340;
  color: #ffffff;
  margin-left: 12px;
}
</style>